export const normalizeExpenseTypes = (expenseTypes = []) =>
  (expenseTypes || [])
    .filter((x) =>
      [4, 11].includes(Number(x.accountCategoryId)) &&
      x.isActive !== false &&
      x.isActive !== 0
    )
    .map((x) => ({
      ...x,
      id: Number(x.id),
      value: Number(x.id),
      label:
        x.accountSubCategoryName ||
        x.accountCategoryName ||
        x.accountCategory ||
        x.name ||
        `Expense Type ${x.id}`,
    }));
